const purple = {
  title: "purple",
  colors: {
    backgroundDark: "#151718",
    backgroundLight: "#151718",
    primary: "#32275F",
    secundary: "#EAEBEB",
    separtor: "#373C3F",
  }
}

export default purple